export enum ApprenticeLocation {
  ONLINE = "online",
  PHYSICAL = "physical",
}
